<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";
import DefaultParamDemo from "~/features/python/ch2/functions/components/DefaultParamDemo.vue";
import FunctionBuilder from "~/features/python/ch2/functions/components/FunctionBuilder.vue";
import FunctionExecution from "~/features/python/ch2/functions/components/FunctionExecution.vue";
import FunctionsQuiz from "~/features/python/ch2/functions/components/FunctionsQuiz.vue";
import ReturnVisualizer from "~/features/python/ch2/functions/components/ReturnVisualizer.vue";
import ModulesQuiz from "~/features/python/ch2/modules/components/ModulesQuiz.vue";
import { functionsFaqs } from "~/features/python/ch2/functions/data/functions.content";
import { buildComputerCollectionSchema } from "~/features/computer/data/seo/computer-schema";
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

const relatedCards = pythonInteractiveCards.filter((item) => item.to !== "/11th/computer/python/functions/");

usePageSeo({
  title: "Chapter 2 Python Functions | Ustaad",
  description: "Chapter 2 Python functions page with function builder, execution flow, return visualizer, default parameter demo and quiz.",
  keywords: "chapter 2 python functions, python functions class 11, return vs print python, function builder",
  faqs: functionsFaqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Ch 2 Python", item: "/11th/computer/python/" },
    { name: "Functions", item: "/11th/computer/python/functions/" },
  ],
  schemaType: "CollectionPage",
  schemaProperties: buildComputerCollectionSchema({
    about: "Chapter 2 Python Functions",
    items: [
      { name: "Chapter 2 Python", path: "/11th/computer/python/" },
      { name: "Chapter 2 Python Variables", path: "/11th/computer/python/variables/" },
      { name: "Chapter 2 Python Programs", path: "/11th/computer/python/programs/" },
      { name: "Chapter 2 Python MCQs", path: "/11th/computer/python/mcqs/" },
    ],
  }),
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="rounded-3xl bg-slate-950 p-6 text-white">
        <p class="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300">Python Chapter 2</p>
        <h1 class="mt-2 text-2xl font-bold tracking-tight">Chapter 2 Python Functions</h1>
        <p class="mt-3 text-sm leading-7 text-slate-200">
          Yahan aap samjhoge ke function chhota helper hota hai jo kaam ko aasaan banata hai. Phir dekhoge ke value andar kaise jati hai aur bahar kaise aati hai.
        </p>
      </section>

      <section class="grid gap-6 lg:grid-cols-2">
        <FunctionBuilder />
        <ReturnVisualizer />
      </section>

      <section class="grid gap-6 lg:grid-cols-2">
        <FunctionExecution />
        <DefaultParamDemo />
      </section>

      <FunctionsQuiz />

      <section class="rounded-3xl border border-slate-200 bg-white p-5">
        <div class="space-y-1">
          <h2 class="text-lg font-semibold text-slate-900">Aik extra cheez</h2>
          <p class="text-sm text-slate-600">Functions ke baad modules bhi dekh lo, taake agla topic ajeeb na lage.</p>
        </div>
        <div class="mt-4">
          <ModulesQuiz />
        </div>
        <NuxtLink
          to="/11th/computer/python/modules/"
          class="mt-4 inline-flex text-sm font-semibold text-sky-700 hover:text-sky-900"
        >
          Modules bhi dekh lo ->
        </NuxtLink>
      </section>

      <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5">
        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">More Topics</p>
          <h2 class="mt-2 text-lg font-semibold text-slate-900">More Python Topics</h2>
        </div>
        <div class="mt-4 grid gap-3 md:grid-cols-3">
          <NuxtLink
            v-for="item in relatedCards"
            :key="item.to"
            :to="item.to"
            class="rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-sky-300 hover:bg-sky-50"
          >
            <h3 class="text-sm font-semibold text-slate-900">{{ item.title }}</h3>
            <p class="mt-2 text-sm leading-6 text-slate-600">{{ item.description }}</p>
          </NuxtLink>
        </div>
      </section>
    </div>
  </PageContainer>
</template>
